import React, { ReactElement } from 'react';

type Props = {
  height?: number | string;
  style?: React.CSSProperties;
  width?: number | string;
};

const Add = (props: Props): ReactElement => {
  const { height, style, width } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 25 24"
    >
      <g fill="none" fillRule="evenodd">
        <g fill="#0074CC" fillRule="nonzero">
          <path
            d="M16.802 6.188L12 10.99 7.202 6.193c-.286-.263-.722-.255-.993.016l-.052.058c-.225.28-.208.692.052.952L10.99 12l-4.796 4.798c-.263.286-.255.722.016.993.271.27.707.28.989.02L12 13.01l4.798 4.797c.286.263.722.255.993-.016l.052-.058c.225-.28.208-.692-.052-.952l-4.781-4.782 4.797-4.797c.263-.286.255-.722-.016-.993-.271-.27-.707-.28-.989-.02z"
            transform="translate(-626 -403) translate(547 98) translate(16 -454) translate(16 64) translate(1 687) translate(46.5 8) rotate(45 12 12)"
          />
        </g>
      </g>
    </svg>
  );
};

Add.defaultProps = {
  width: '100%',
  height: '100%',
};

export default Add;
